import { render } from "./advertize_master.vue?vue&type=template&id=70e0dac8&scoped=true"
import script from "./advertize_master.vue?vue&type=script&lang=js"
export * from "./advertize_master.vue?vue&type=script&lang=js"

import "./advertize_master.vue?vue&type=style&index=0&id=70e0dac8&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e0dac8"]])

export default __exports__